import { Button, Divider, Grid, Typography, useMediaQuery, useTheme } from "@mui/material"
import { useEffect, useState } from "react";
import { AutocompleteInput, Create, ReferenceInput, required, SimpleForm, TextInput, Toolbar, useNotify } from "react-admin"
import { allStates, getCountry } from "../../services/State";
import SaveIcon from '@mui/icons-material/Save';
import { createSubMerchant } from "../../services/SubMerchant";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import OtherHousesIcon from '@mui/icons-material/OtherHouses';
import Color from "../layout/color/Color";
import FontSize from "../layout/FontSize";

const saveButton = {
  bgcolor: Color.Main,
  borderRadius: '30px',
  border: '1px solid Color.Main',
  fontWeight: '500',
  textAlign: 'center',
  padding: '8px 15px',
  color: Color.Button,
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Button, color: Color.Normal }
};

const backButton = {
  bgcolor: Color.Button,
  borderRadius: '30px',
  border: "1px solid #055C2D",
  color: Color.Main,
  fontWeight: '500',
  textAlign: 'center',
  padding: '8px 15px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Main, color: Color.Button }
};
const SubMerchantCreateToolbar = (props) => {
  const submerchant = props.record;
  const notify = useNotify();
  const navigate = useNavigate();
  const handleCreateSubMerchant = async (e) => {
    try {
      e.preventDefault();
      const respone = await createSubMerchant(submerchant);
      if (respone.id !== undefined) {
        notify(`Submerchant created`, { type: 'success' })
        navigate('/SubMerchant')
      }
      else notify("Create error", { type: 'errorr' })
    } catch (err) {
      notify(`Create error`, { type: 'errorr' })
    }
  }
  const handleBack = (e) => {
    e.preventDefault();
    navigate('/SubMerchant')
  }
  return (
    <Toolbar sx={{ justifyContent: 'space-between' }} {...props}>
      <Button
        startIcon={<KeyboardBackspaceIcon />}
        onClick={handleBack}
        sx={backButton}
      >
        Back
      </Button>
      <Button sx={saveButton} startIcon={<SaveIcon />} onClick={handleCreateSubMerchant}>Save</Button>
    </Toolbar>
  )
}

const submerchantField = [
  {
    id: 'name',
    label: 'Name',
    required: false
  },
  {
    id: 'submerchantID',
    label: 'SubMerchant',
    required: true
  },
  {
    id: 'zip',
    label: 'Zip',
    required: false
  },
  {
    id: 'state',
    label: 'State',
    required: false
  },
  {
    id: 'city',
    label: 'City',
    required: false
  },
  {
    id: 'address',
    label: 'Address',
    required: true
  },
  {
    id: 'phone',
    label: 'Phone Number',
    required: true
  },
  {
    id: 'email',
    label: 'Email',
    required: true
  },
  {
    id: 'bankAccount',
    label: 'Bank Account',
    required: false
  }
]


export const SubMerchantCreate = (props) => {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [country, setCountry] = useState(null);
  const [submerchant, setSubmerchant] = useState({
    name: '',
    merchantID: parseInt(localStorage.getItem('merchantID')),
    submerchantID: null,
    zip: null,
    state: null,
    city: null,
    phone: null,
    email: null,
    address: null,
    bankAccount: null
  })
  useEffect(() => {
    const fetchAPI = async () => {
      try {
        if (country !== null) {
          const response = await allStates(country);
          if (response !== null && response !== undefined)
            setStates(response);
        }
      } catch (err) {
        console.log(err);
      }
    }
    fetchAPI();
  }, [country])

  useEffect(() => {
    const fetchAPI = async () => {
      try {
        const response = await getCountry(parseInt(localStorage.getItem('merchantID')));
        if (response !== null && response !== undefined)
          setCountry(response.country)
      } catch (err) {
        console.log(err);
      }
    }

    fetchAPI();
  }, [])

  return (
    <Create {...props}>
      <SimpleForm toolbar={<SubMerchantCreateToolbar record={submerchant} />}>
        <Grid sx={{ textAlign: 'left' }}>
          <Button endIcon={<OtherHousesIcon sx={{ color: Color.Main }} />} sx={{ textAlign: 'left', ml: 1, cursor: 'default' }} size="medium">
            <Typography variant="h3">
              Create SubMerchant
            </Typography>
          </Button>
        </Grid>
        <Divider sx={{ width: '100%', mb: 4 }} />
        <Grid container spacing={2} item
          sx={{ px: `${matchDownSM ? '2rem' : '15rem'}` }}
        >
          {submerchantField.map((p, index) => {
            return p.id === 'submerchantID' ? (
              <Grid item xs={12} md={6} key={index}>
                <ReferenceInput source="submerchantID" reference="SubMerchant">
                  <AutocompleteInput
                    optionText='name'
                    label={p.label}
                    variant="outlined"
                    fullWidth
                    value={submerchant[p.id]}
                    onChange={(newValue) => {
                      setSubmerchant({ ...submerchant, [p.id]: newValue })
                    }
                    }
                    filterToQuery={searchText => ({ name: [searchText] })}
                  />
                </ReferenceInput>
              </Grid>
            ) : p.id === 'merchantID' ? (
              <Grid item xs={12} md={6} key={index}>
                <ReferenceInput source="merchantID" reference="Merchant">
                  <AutocompleteInput
                    optionText='name'
                    label={p.label}
                    variant="outlined"
                    fullWidth
                    validate={required()}
                    value={submerchant[p.id]}
                    onChange={(newValue) => setSubmerchant({ ...submerchant, [p.id]: newValue })}
                    filterToQuery={searchText => ({ name: [searchText] })}
                  />
                </ReferenceInput>
              </Grid>
            ) : p.id === 'state' ? (
              <Grid item xs={12} md={6} key={index}>
                <AutocompleteInput
                  optionText='name'
                  fullWidth
                  variant="outlined"
                  source={p.id}
                  label={p.label}
                  choices={states}
                  value={submerchant[p.id]}
                  onChange={(newValue) => {
                    setSubmerchant({ ...submerchant, [p.id]: newValue, city: null })
                    setCities(() => {
                      const stateCity = states.filter((e) => e.id === newValue);
                      if (stateCity.length === 0) return [];
                      return stateCity[0].apollo_reference_city;
                    })
                  }}
                />
              </Grid>
            ) : p.id === 'city' ? (
              <Grid item xs={12} md={6} key={index}>
                <AutocompleteInput
                  optionText='name'
                  fullWidth
                  source={p.id}
                  variant="outlined"
                  value={submerchant[p.id]}
                  label={p.label}
                  choices={cities}
                  onChange={(newValue) => {
                    setSubmerchant({ ...submerchant, [p.id]: newValue })
                  }}
                />
              </Grid>
            ) : (
              <Grid item xs={12} md={6} key={index}>
                <TextInput
                  variant="outlined"
                  label={p.label}
                  fullWidth
                  source={p.id}
                  value={submerchant[p.id]}
                  required
                  onChange={(event) => setSubmerchant({ ...submerchant, [p.id]: event.target.value })}
                />
              </Grid>
            )
          })}
        </Grid>
      </SimpleForm>
    </Create>
  )
}